module.exports = __webpack_public_path__ + "static/img/jd.f3da0fd7.png";